import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const InputGroup = styled.div`
  display: flex;
  width: 100%;
`;

export const InputWrapper = styled.div`
  input {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-right: none;
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  button {
    font-size: ${rem(14)};
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    padding: ${rem(0)} ${rem(13)};
    margin-top: ${rem(24)};
    width: 100%;
  }
`;
